<script>
export default {
    props: {
        item: { type: Object, default () {} }
    }
}
</script>
<template>
    <span>
        <!-- //issue 679 -->
        <template v-if="item.request.type === 'raw_log' && item.response.id">
            <span>
                Id : {{ item.response.id }}
            </span>
        </template>
        <template v-else>
            <span v-for="i in item.record" :key="i.key">
                <i style="opacity:0.5">{{ i.key }} :</i> <span>{{ i.value }}</span> <br/>
            </span>
            <span v-if="item.request && item.request.status">
                <i style="opacity:0.5">Status :</i> <span>{{item.request.status}}</span> <br/>
            </span>
        </template>
        <!-- //issue 679 -->
</span>
</template>